Vue.component('import-objects', {
    props: ['user'],
    data: function () {
        return {
            excelData: undefined,
            headers: undefined,
            colwisedata: undefined,
            finaldata: undefined,
            fieldsDefinition: undefined,
            form:{
                fieldsDefinitionId: null,   // Felddefinition
                fieldsAssignment: {},     // Zuweisung der Excel-Felder zu vorhandenen
                categoryId: null,
                locationId: null,
                availabilityId: null,
                note: null,
                image: {}
            },
        }
    },
    methods: {
        /**
         * Eventhandler wird ausgelöst, wenn die Auswahl der Formularfelddefinition geändert wurde
         * @param e
         */
        onFieldSetDefinitionSelect(e){
            // Standarfverhalten auf jeden Fall abbrechen und manuell die Werte setzen
            e.preventDefault();
            this.confirmSelectionChange(e, e.dataItem.id, e.sender.value());
        },
        /**
         * Bestätigt den Wechsel der Formularfelddefinition
         * @param e
         */
        confirmSelectionChange(e, definitionId, oldId){
            console.log("select", e, definitionId, oldId);
            if(!_.isEmpty(this.fieldsDefinitionFilledData) && (this.form.fieldsDefinitionId != definitionId || definitionId <= 0)){
                // Wenn wieder auf "Bitte wählen" geschaltet wird Daten zurücksetzen. (ggf. Warnung)
                swal.fire({
                    title: "Erweiterte Felder verlassen",
                    text: "Ihre bereits eingegebenen Daten in den zusätzlichen Feldern gehen verloren",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: 'Abbrechen',
                    confirmButtonText: 'Ok'
                }).then((willDelete) => {
                    if (willDelete.value) {
                        // Felddefinition wechseln
                        this.fieldsDefinitionFilledData = {};
                        this.convertedFields=null;
                        e.sender.value(definitionId);
                        this.loadFieldSetDefinition(e, e.sender.value());
                    } else {
                        // Aktuelle Felddefinition doch nicht wechseln (zurück zur alten)
                        e.sender.value(oldId);
                        return;
                    }
                });
            }else{
                console.log("normales laden der Felddefinition");
                this.convertedFields=null;
                this.form.fieldsDefinitionId = definitionId;
                e.sender.value(definitionId);
                this.loadFieldSetDefinition(e, e.sender.value());
            }
        },

        /**
         * Lädt die Formularfelddefinition
         * @param definitionId
         */
        loadFieldSetDefinition(e, definitionId){
            console.log("loadfieldsetdefinition?", e, definitionId);
            this.form.fieldsDefinitionId = definitionId;
            if(definitionId !== "" && definitionId !== null && definitionId !== undefined){
                axios.get('/api/rmsobjects/fieldsdefinitions/id/' + definitionId)
                    .then(response => {
                        console.log("loadfieldsetdefinition response", response);
                        this.fieldsDefinition = response.data;
                        this.buildForm(this.fieldsDefinition);
                    });
            }
        },

        buildForm: function(){
          console.log("building form...");

        },

        onClickCreate: function(evt){
            window.open('/objects/create', '_self');
        },
        onComplete: function(){
            console.warn("onComplete");
            //alert('Yay. Done!');

            // Hier die Daten in die DB eintragen
                    },

        onTabChange: function(a,b){
            if(b == 2){
                this.buildGrids();
            }

            if(b == 3){
                // Letzte Seite - Einfügen vorbereiten
                this.prepareInsertion();
                this.insertData();
            }
        },

        prepareInsertion: function () {
            console.log("preparing insertion");
        },

        clickTest: function(){
            console.log("clickTest");
            console.log(this.colwisedata);
            console.log(this.headers);
            console.log(this.form);
        },

        colAssignmentChanged: function(e){
            console.log("col assignment changed", e);
            console.log(this.form.fieldsAssignment);
            this.form.fieldsAssignment[e.header] = e;
        },
        insertData:function(){
            axios.post('/import/createObjects/RMS', {
                colwisedata: this.colwisedata,
                header: this.headers,
                fieldsAssignment: this.form.fieldsAssignment,
                fieldsDefinitionId: this.form.fieldsDefinitionId,
                formx: this.form
            })
            .then(function (response) {
                console.log("response",response);
            })
            .catch(function (error) {
                console.log("error",error);
            });


        },

        validateAsync:function() {
            console.log("xx");
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    if(this.count < 1){
                        this.count ++;
                        reject('This is a custom validation error message. Click next again to get rid of the validation');
                    }else{
                        this.count = 0;
                        resolve(true);
                    }
                }, 1000)
            })
        },

        uploadFile: function(){
            this.loadSpreadSheet();
            return new Promise((resolve, reject) => {
                let data = new FormData();

                data.append('uploadFile', this.$refs.uploadFile.files[0]);

                if(this.$refs.uploadFile.files.length > 0) {
                    console.log("jetzt aber", data);
                    axios.post('data', data)
                        .then( (response) => {
                            console.log("uploaded", response);
                            console.log(response.data);
                            this.excelData = response.data;
                            resolve(true);
                        })
                }
            })
        },



        buildGrids: function(){
            gridData = this.excelData;
            // Spaltenweise auslesen
            console.log("gridData", gridData);

            var colWiseData = [];
            var headers = [];
            var rowCounter = 0;
            var cellCounter = 0;

            for (var rowData in gridData) {
                //console.log("row",rowData, gridData[rowData]);
                cellCounter=0;
                let tmpCol = {};
                for(var cellData in gridData[rowData]){

                    //console.log("cell", cellData, gridData[rowData][cellData]);

                    // Header-Array füllen, wenn es sich um die angegebene Zeile handelt
                    if((rowCounter+1) == this.$refs.rowNumHeader.value){
                        // Header nur füllen, wenn ein Headername gesetzt ist
                        if(gridData[rowData][cellData] != null && gridData[rowData][cellData] != undefined && gridData[rowData][cellData] != "")
                            headers[cellCounter] = gridData[rowData][cellData];
                    }else if((rowCounter+1) >= this.$refs.rowNumFirstData.value){
                        tmpCol[headers[cellCounter]] = gridData[rowData][cellData];
                    }
                    cellCounter++;
                }
                if(Object.keys(tmpCol).length !== 0){
                    colWiseData.push(tmpCol);
                }
                rowCounter++;
            }

            console.log("headers", headers);
            console.log("colwisedata", colWiseData);

            this.headers = headers;
            this.colwisedata = colWiseData;



            //var tmp = new importcol();
            //console.log(tmp);


            // Verfügbare angelegte Felder auslesen

            // Grids für jede Spalte aufbauen, dropdown druntersetzen um verknüpfung herzustellen

            // Daten für eine Spalte aufbereiten


        },

        parameterMap: function(options, operation) {
            if (operation !== 'read' && options.models) {
                return { models: kendo.stringify(options.models) };
            }
        },

        loadSpreadSheet: function(){
            var spreadsheet = this.$refs.spreadsheet.kendoWidget();
            spreadsheet.element.css('height', '500px');
            spreadsheet.element.css('width', '100%');
            console.log("loading sheet" + this.$refs.uploadFile.files[0]);
            spreadsheet.fromFile(this.$refs.uploadFile.files[0]);
            console.log("loaded sheet");
            spreadsheet.resize();
            setTimeout(function(){  spreadsheet.refresh(); }, 1000);

        },
        onSelect (arg) {
            console.log("New range selected. New value: " + arg.range);
        },
    },
    mounted(){
    }
});
